import React from 'react';
import PropTypes from 'prop-types';
import {useDropzone} from 'react-dropzone';
import classnames from 'classnames';
import {useDispatch, useSelector} from 'react-redux';
import Icon from 'shared/components/icon';
import {uploadImage} from 'shared/actions/minerva';
import 'stylesheets/components/shared-form-photo-upload.scss';

const propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
};

export const PhotoUpload = ({value, onChange}) => {
  const dispatch = useDispatch();
  const uploading = useSelector((state) => state.uploading);
  const deletePhoto = () => onChange('');
  const upload = async (file) => {
    await dispatch(uploadImage(file));
    onChange();
  };

  const {getRootProps, getInputProps} = useDropzone({
    accept: {'image/*': []},
    multiple: false,
    onDrop: upload,
  });

  return value ? (
    <div className="shared-form-photo-upload-image-container">
      <button
        type="button"
        className="shared-form-photo-upload-delete-button"
        onClick={deletePhoto}
      >
        <Icon iconType="times-r" className="shared-form-photo-upload-delete-icon" />
      </button>
      <img src={value} alt="" className="shared-form-photo-upload-image" data-testid={value} />
    </div>
  ) : (
    <div
      className="shared-form-photo-upload-dropzone-container"
      data-testid="photo-upload-dropzone"
    >
      <p className="shared-form-photo-upload-dropzone-subtitle">Max file size 20MB</p>
      <div className="shared-form-photo-upload-dropzone" {...getRootProps()}>
        <input {...getInputProps()} aria-label="Photo upload" />
        <div className="shared-form-photo-upload-button">
          <Icon
            iconType={uploading ? 'spinner' : 'plus-r'}
            className={classnames('shared-form-photo-upload-icon', {'rm-spin': uploading})}
          />
        </div>
      </div>
    </div>
  );
};

PhotoUpload.propTypes = propTypes;

export default PhotoUpload;
